import { render, staticRenderFns } from "./G11n.vue?vue&type=template&id=d44c1a38&"
import script from "./G11n.vue?vue&type=script&lang=js&"
export * from "./G11n.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports